<div class="container">
  <div class="actions">
    <button class="btn-action" (click)="openCreate()" *ngIf="isSuperUser">
      <fa-icon [icon]="['fas', 'square-plus']"></fa-icon>
      Create Subscription
    </button>
    <div class="upload-section" *ngIf="isSuperUser">
      <button class="btn-action" (click)="openUploadModal()">
        <fa-icon [icon]="faUpload"></fa-icon>
        Upload Quotation
      </button>
    </div>
  </div>
  <div class="container">
    <div class="container-table">
      <header class="top-header">
        <h3>Subscriptions</h3>
        <p>Manage subscription contracts</p>
      </header>

      <!-- <div class="actions">
        <button class="btn-action" (click)="openCreate()" *ngIf="isSuperUser">
          <fa-icon [icon]="['fas', 'square-plus']"></fa-icon>
          Create Subscription
        </button>
        <div class="upload-section" *ngIf="isSuperUser">
          <button class="btn-action" (click)="openUploadModal()">
            <fa-icon [icon]="faUpload"></fa-icon>
            Upload Quotation
          </button>
        </div>
      </div> -->

      <div class="table-filters">
        <div class="filter-field">
          <label>Search</label>
          <input type="text" placeholder="Search by org or customer contact" [(ngModel)]="searchText" (change)="onFiltersChange()" />
        </div>
        <div class="filter-field">
          <label>Status</label>
          <select [(ngModel)]="statusFilter" (change)="onFiltersChange()">
            <option value="">All Status</option>
            <option value="ACTIVE">Active</option>
            <option value="EXPIRING">Expiring Soon</option>
            <option value="EXPIRED">Expired</option>
            <option value="CANCELLED">Cancelled</option>
          </select>
        </div>
        <div class="filter-field">
          <label>Billing</label>
          <select [(ngModel)]="billingFilter" (change)="onFiltersChange()">
            <option value="">All Billing</option>
            <option value="ANNUAL">Annual</option>
            <option value="UPFRONT">Upfront</option>
          </select>
        </div>
        <div class="filter-field" *ngIf="isSuperUser">
          <label>Organization</label>
          <select [(ngModel)]="selectedOrgId" (change)="onFiltersChange()">
            <option value="">All Organizations</option>
            <option *ngFor="let org of organizations" [value]="org.id">{{ org.name }}</option>
          </select>
        </div>
      </div>

      <div class="responsive-table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Organization</th>
              <th>Customer POC</th>
              <th>Cameras</th>
              <th>Billing Type</th>
              <th>Start Date</th>
              <th>Next Payment Due Date</th>
              <th>Contract End Date</th>
              <th>Duration</th>
              <th>Total Amount</th>
              <th>Pending</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="loading">
              <td colspan="12">Loading subscriptions...</td>
            </tr>
            <tr *ngFor="let sub of subscriptions">
              <td>{{ sub.organization_name }}</td>
              <td>
                {{ getCustomerPocName(sub) }}
                <div class="muted">{{ getCustomerPocEmail(sub) }}</div>
              </td>
              <td>
                <span class="camera-count">{{ sub.cameras ?? '-' }}</span>
              </td>
              <td>{{ sub.billing_type }}</td>
              <td>{{ sub.start_date | date: 'dd/MM/yyyy' }}</td>
              <td>{{ sub.next_payment_due_date ? (sub.next_payment_due_date | date: 'dd/MM/yyyy') : '-' }}</td>
              <td>{{ sub.expiry_date | date: 'dd/MM/yyyy' }}</td>
              <td>{{ sub.contract_duration_years }}y</td>
              <td>{{ sub.currency }} {{ sub.total_amount }}</td>
              <td>{{ sub.currency }} {{ sub.pending_amount || '0.00' }}</td>
              <td>
                <span class="status-pill" [class.active]="sub.status === 'ACTIVE'"
                  [class.expiring]="sub.status === 'EXPIRING'" [class.expired]="sub.status === 'EXPIRED'"
                  [class.cancelled]="sub.status === 'CANCELLED'">
                  {{ sub.status }}
                </span>
              </td>
              <td class="table-actions-cell">
                <div class="table-actions">
                  <button class="action-button" type="button" (click)="openDetail(sub.id)" title="View"
                    aria-label="View subscription">
                    <fa-icon [icon]="['fas', 'eye']" class="fa-light"></fa-icon>
                  </button>
                  <button *ngIf="isSuperUser" class="action-button bt-edit" type="button" (click)="openEdit(sub.id)"
                    title="Edit" aria-label="Edit subscription">
                    <span><fa-icon [icon]="['fas', 'pen']" class="fa-light"></fa-icon></span>
                  </button>
                  <button *ngIf="isSuperUser" class="action-button bt-delete" type="button"
                    (click)="openConfirmationDialog(sub.id)" title="Delete" aria-label="Delete subscription">
                    <span><fa-icon [icon]="['fas', 'trash']" class="fa-light"></fa-icon></span>
                  </button>
                </div>
              </td>
            </tr>
            <tr *ngIf="!loading && subscriptions.length === 0">
              <td colspan="12">No subscriptions found.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- <div class="footer">
      <div class="total-records">Total Records: {{ totalRecords }}</div>
      <div class="pagination-controls">
        <label for="recordsPerPage">Records per page </label>
        <select id="recordsPerPage" [(ngModel)]="recordsPerPage" (change)="selectPageSize()">
          <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
        </select>
        <span>{{ currentPage }} / {{ totalPages }}</span>
        <button (click)="previous()" [disabled]="!previousPage" class="change-page">‹</button>
        <button (click)="next()" [disabled]="!nextPage" class="change-page">›</button>
      </div> -->
      <div class="footer">
        <div class="total-records">Total Records: {{ totalRecords }}</div>
          <app-vte-pagination
                  [currentPage]="currentPage"
                  [pageSize]="recordsPerPage"
                  [totalRecords]="totalRecords"
                  [showJumpToPage]="true"
                  (pageChange)="onPageChange($event)"
                  (pageSizeChange)="onPageSizeChange($event)">
          </app-vte-pagination>
      </div>
    </div>
  </div>
</div>

<!-- Upload Quotation Modal -->
<div *ngIf="showUploadModal" class="confirmation-modal">
  <div class="modal-content upload-modal-content">
    <div class="modal-header upload-modal-header">
      <h3>Upload Quotation</h3>
      <p>Upload a PDF quotation document to process</p>
    </div>
    <div class="modal-body">
      <div class="drop-zone" [class.drag-over]="isDragOver" (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)" (drop)="onDrop($event)" (click)="quotationFileInput.click()">
        <input #quotationFileInput id="quotationFile" type="file" (change)="onQuotationSelected($event)"
          accept="application/pdf" style="display:none" />
        <div class="drop-zone-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 24 24" fill="none"
            stroke="#374151" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" />
            <path d="M12 12v9" />
            <path d="m16 16-4-4-4 4" />
          </svg>
        </div>
        <p class="drop-zone-text">Drag and drop your file here</p>
        <p class="drop-zone-or">— OR —</p>
        <button class="browse-btn" type="button" (click)="$event.stopPropagation(); quotationFileInput.click()">Browse
          files</button>
      </div>
      <div *ngIf="quotationFile" class="selected-file-info">
        <i class="bi bi-file-earmark-pdf-fill"></i>
        <span>{{ selectedFileName }}</span>
        <button class="remove-file-btn" type="button" (click)="clearSelectedFile()" title="Remove file">✕</button>
      </div>
      <div class="quotation-upload-fields">
        <div class="quotation-upload-field">
          <label for="quotationCustomerPocEmail">Customer POC Email</label>
          <input
            id="quotationCustomerPocEmail"
            type="email"
            [(ngModel)]="quotationCustomerPocEmail"
            [ngModelOptions]="{ standalone: true }"
            placeholder="Required if the PDF does not contain it" />
        </div>
        <div class="quotation-upload-field">
          <label for="quotationCustomerPocPhone">Customer POC Phone</label>
          <input
            id="quotationCustomerPocPhone"
            type="text"
            [(ngModel)]="quotationCustomerPocPhone"
            [ngModelOptions]="{ standalone: true }"
            placeholder="Required if the PDF does not contain it" />
        </div>
        <div class="quotation-upload-field">
          <label for="quotationSubscriptionStartDate">Subscription Start Date</label>
          <input
            id="quotationSubscriptionStartDate"
            type="date"
            [(ngModel)]="quotationSubscriptionStartDate"
            [ngModelOptions]="{ standalone: true }" />
        </div>
      </div>
      <p class="quotation-upload-note">
        Enter customer contact details if they are not available in the quotation.
      </p>
      <div class="error" *ngIf="uploadError" style="padding: 0 4px;">
        <small>{{ uploadError }}</small>
      </div>
    </div>
    <div class="button-row">
      <button class="btn-cancel" (click)="closeUploadModal()">
        <fa-icon [icon]="['fas', 'square-xmark']" style="padding-right: 3px;"></fa-icon>
        Cancel
      </button>
      <button (click)="uploadQuotation()" class="btn-save" [disabled]="!quotationFile">
        <fa-icon [icon]="['fas', 'file-upload']" style="padding-right: 3px;"></fa-icon>
        Upload
      </button>
    </div>
  </div>
</div>

<!-- Modal Confirmation dialog -->
<div *ngIf="showConfirmationDialog" class="confirmation-modal">
  <div class="modal-content">
    <div class="modal-header">
      <i class="bi bi-exclamation-triangle warning-icon"></i>
      <h3>Are You Sure?</h3>
    </div>
    <div class="modal-body">
      <p>Do you want to permanently delete this record? Confirm your choice below!</p>
    </div>
    <div class="modal-footer">
      <button (click)="deleteSubscription()" class="confirm-btn modal-red">Yes, Proceed</button>
      <button (click)="closeConfirmationDialog()" class="cancel-btn cancel-btn-green">Cancel</button>
    </div>
  </div>
</div>
